/**
 * Toaster Component
 * Toast notification container using Sonner.
 * @packageDocumentation
 */

import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * Toast notification container component.
 *
 * @param { ToasterProps } props Component props.
 * @returns { JSX.Element } The toaster container element.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      style={
        {
          '--info-bg': 'var(--info)',
          '--info-border': 'var(--info)',
          '--normal-bg': 'var(--popover)',
          '--success-bg': 'var(--success)',
          '--warning-bg': 'var(--warning)',
          '--normal-border': 'var(--border)',
          '--error-bg': 'var(--destructive)',
          '--success-border': 'var(--success)',
          '--warning-border': 'var(--warning)',
          '--error-border': 'var(--destructive)',
          '--info-text': 'var(--info-foreground)',
          '--normal-text': 'var(--popover-foreground)',
          '--success-text': 'var(--success-foreground)',
          '--warning-text': 'var(--warning-foreground)',
          '--error-text': 'var(--destructive-foreground)',
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          description: 'group-[.toast]:text-muted-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          info: 'group-[.toaster]:bg-info/10 group-[.toaster]:text-info group-[.toaster]:border-info/20',
          success: 'group-[.toaster]:bg-success/10 group-[.toaster]:text-success group-[.toaster]:border-success/20',
          warning: 'group-[.toaster]:bg-warning/10 group-[.toaster]:text-warning group-[.toaster]:border-warning/20',
          error:
            'group-[.toaster]:bg-destructive/10 group-[.toaster]:text-destructive group-[.toaster]:border-destructive/20',
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
